export default __webpack_public_path__ + "static/media/privatelogo.0a5c4aa7.png";